export default async function getSystemParams() {
  const currentEnv = Wiz.GetModuleConfig('legacy-resource').currentEnv
  const res = await axios.get(
    `${currentEnv.VUE_APP_STANDARD_SERVER}/api/std/SystemSetting/system-parameter-list`
  )
  if (res && res.data && res.data.code === 0 && res.data.data) {
    localStorage.setItem('systemParams', JSON.stringify(res.data.data))
  }
}
